module.exports = __webpack_public_path__ + "static/media/Pin.0ea4925d.svg";